import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AnalyticsConsentState {
  hasConsent: boolean;
}

const initialState: AnalyticsConsentState = {
  hasConsent: false
};

const AnalyticsConsentSlice = createSlice({
  name: 'hasConsent',
  initialState,
  reducers: {
    setAnalyticsConsent: (
      state: AnalyticsConsentState,
      action: PayloadAction<boolean>
    ) => {
      state.hasConsent = action.payload;
    }
  }
});

export const { setAnalyticsConsent } = AnalyticsConsentSlice.actions;
export default AnalyticsConsentSlice.reducer;
